export interface ComponentIdentityTextSpecification {
	id: number;
	text: string;
}

export class ComponentIdentityText {
	public readonly id: number;
	public readonly text: string;

	constructor(spec: ComponentIdentityTextSpecification) {
		this.id = spec.id;
		this.text = spec.text;
	}
}
